import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice de durée de batterie - Calculer les heures de fonctionnement de la batterie";
const DESCRIPTION =
  "Calculatrice de durée de batterie - Calculer les heures de fonctionnement de la batterie. Outil en ligne en francais pour obtenir un resultat rapide, clair et utile dans vos besoins du quotidien.";
const KEYWORDS =
  "battery life calculator, calculatrice en ligne, outil pratique, utilitaire quotidien, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/battery-life-calculator/";

function BatteryLifeCalculator() {
  const [batteryCapacity, setBatteryCapacity] = useState("0");
  const [deviceCurrentDraw, setDeviceCurrentDraw] = useState("0");
  const [operatingTime, setOperatingTime] = useState(null);
  const [error, setError] = useState("");

  const calculateOperatingTime = () => {
    try {
      if (batteryCapacity === "0" && deviceCurrentDraw === "0") {
        setError("Veuillez entrer des valeurs pour calculer le temps de fonctionnement");
        return;
      }
      const time = batteryCapacity / deviceCurrentDraw;
      setOperatingTime(time);
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice offre un moyen simple de calculer le temps de fonctionnement de la batterie
                  lorsqu'elle est connectée à un appareil particulier. Le temps de fonctionnement dépend de la capacité
                  de la batterie et du courant fourni par l'appareil.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="battery-capacity">Capacité de la batterie (ampères-heures):</label>
                    <input
                      id="battery-capacity"
                      type="number"
                      value={batteryCapacity}
                      onChange={(e) => setBatteryCapacity(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="device-draw">Courant du dispositif (ampères):</label>
                    <input
                      id="device-draw"
                      type="number"
                      value={deviceCurrentDraw}
                      onChange={(e) => setDeviceCurrentDraw(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                  </div>
                  <button onClick={calculateOperatingTime} className="btn btn-success">Calculer</button>
                </div>
              </div>
              <div className="col-sm-12 col-md-5">
                {operatingTime && (
                  <div className="bg-light p-3 rounded">
                    <h3>Hasil:</h3>
                    <p><strong>Temps de fonctionnement:</strong> {operatingTime.toFixed(2)} heures</p>
                  </div>
                )}
                {error && <div className="alert alert-danger">{error}</div>}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comment fonctionne ce calcul</h3></div>
              <div className="info-section-body"><p>La duree de vie de la batterie est calculee en divisant la capacite (Ah) par le courant consomme par l appareil (A). Le resultat est exprime en heures de fonctionnement.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseil d utilisation</h3></div>
              <div className="info-section-body"><p>Verifiez les specifications techniques de votre appareil pour connaitre le courant consomme. Ce chiffre est generalement indique sur l etiquette ou dans le manuel d utilisation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Facteurs influencant la duree reelle</h3></div>
              <div className="info-section-body"><p>La temperature, l age de la batterie et l intensite d utilisation peuvent reduire la duree reelle par rapport au calcul theorique. Ce resultat est une estimation dans des conditions ideales.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BatteryLifeCalculator;